module.exports = __webpack_public_path__ + "static/media/pg-swacrab.4bb78b50.png";